import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";
import { Redirect, useHistory } from "react-router";
import { RootState } from "../app/store";
import "../styles/components/recentWork.scss";
import Button from "@mui/material/Button";
import CurrentWeek from "./CurrentWeek";
import CustomButton from "../components/CustomButton";
import { Tooltip } from "@mui/material";

interface RecentWorkProps {
  datesWorked: boolean[];
  habitId: number;
}

const WeeklyGraph: React.FC<RecentWorkProps> = ({
  datesWorked,
  habitId,
}: RecentWorkProps) => {
  const [recentWork, setRecentWork] = useState([]);
  const history = useHistory();

  useEffect(() => {
    (async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}/habit/recentWork/${habitId}`,
          {
            headers: { "Content-Type": "application/json" },
            credentials: "include",
          }
        );
        const data = await response.json();

        setRecentWork(data);
      } catch (error) {}
    })();
  }, []);

  async function addTodayWorkDone(
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) {
    e.preventDefault();

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/habit/${habitId}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
        }
      );

      if (response.status === 201) {
        toast.success("Awesome! Work has been recorded for today.");

        //doing this to "refresh" the page to display the newly added work done on the current date
        //refer => https://stackoverflow.com/a/51332885/6438526
        history.push("/empty");
        history.replace("/");
      } else {
        const data = await response.json();
        toast.error(data?.message);
      }
    } catch (error: any) {
      toast.error(error?.message);
    }
  }

  return (
    <>
      <CurrentWeek />
      <div className="recent-work-parent">
        <div className="recent-work">
          {recentWork.map((r) => {
            return (
              <Tooltip
                title={
                  r === true
                    ? "Work registered on this day"
                    : "No work registered on this day"
                }
                placement="top"
              >
                <div
                  className={
                    r === true ? "recent-work-done" : "recent-work-not-done"
                  }
                ></div>
              </Tooltip>
            );
          })}
        </div>

        <CustomButton
          onClick={(e) => addTodayWorkDone(e)}
          displayText="I did this today!"
          style={{
            border: "3px solid black",
            color: "black",
          }}
          variant="text"
          className="work-done-button"
        />
      </div>
    </>
  );
};

export default WeeklyGraph;
